<template>
  <div v-if="rootStore.is_page_loading"

      class="h-screen w-screen inset-0 fixed bg-secondary-black/35 z-[100] grid place-items-center text-idle-black"
  >
    <TsIcon name="eos-icons:bubble-loading" size="40" />
  </div>
</template>

<script setup lang="ts">

const rootStore = useRootStore();

</script>




